import { useTranslation, Trans } from 'react-i18next'
import { showTrustScoreInfoModal } from './base'
import InfoIcon from './info-icon'
import bankruptcy from './images/bankruptcy.png'

const BankruptcyIndex = props => {
  const { t } = useTranslation()

  return (
    <InfoIcon
      {...props}
      onClick={() =>
        showTrustScoreInfoModal({
          title: t('b.liv_score.view.bankruptcy_index.title', 'Bankruptcy Index'),
          description: (
            <Trans i18nKey="b.liv_score.view.bankruptcy_index.text">
              <strong>Bankruptcy Index</strong> shows any bankruptcy records available for the
              renter from within the past 6 years. This is intended to predict the likelihood of a
              renter filing for bankruptcy in the immediate 12-24 months, with more recent records
              leading to a lower score and older records resulting in a higher score.
            </Trans>
          ),
          image: bankruptcy
        })
      }
    />
  )
}

export default BankruptcyIndex
